import { Outlet, useLocation } from 'react-router-dom'
import DashHeader from './DashHeader'
import PageTransition, { sectionKey } from './PageTransition'

const DashLayout = () => {
    const { pathname } = useLocation()

    return (
        <>
            <DashHeader />
            <div className="dash-container">
                {/* Keyed by section, not pathname: /dash and /dash/spread/:id
                    share a key so picking a spread slides instead of
                    remounting Welcome and losing the reading. */}
                <PageTransition transitionKey={sectionKey(pathname)}>
                    <Outlet />
                </PageTransition>
            </div>
        </>
    )
}
export default DashLayout
